<!--
 * @Author: jjchen
 * @Date: 2022-08-11 10:38:51
 * @LastEditors: lz
 * @LastEditTime: 2022-10-10 15:26:48
 * @Description: 测评页
-->
<template>
  <div class="evaluation">
    <div class="pageTop">
      <div class="step">
        <div class="stepText">
          <van-icon name="passed" class="passed" /> <span>选择企业</span
          ><van-icon name="arrow" class="arrowOne" />
        </div>
        <div class="stepText">
          <div class="numOne">2</div>
          <span class="write">填写测评表</span
          ><van-icon name="arrow" class="arrowTwo" />
        </div>
        <div class="stepText">
          <div class="numTwo">3</div>
          <span class="getReport">生成评估报告</span>
        </div>
      </div>
    </div>
    <div class="progress">
      <div class="proMiddle"></div>
    </div>
    <div class="pageHead">
      <svg-icon icon-class="gx-evaluation" class="gx-evaluation"></svg-icon
      ><span class="title">国家高新技术企业测评表</span
      ><span>（预计填写时间：1分钟）</span>
    </div>
    <div class="partOne" v-show="isShow.one">
      <div class="formItem">
        <dropDown
          ref="dropDownRef"
          :companyList="companyList"
          :visible.sync="visible"
          :flag="1"
          :loading="loading"
          :isEmpty="isEmpty"
          class="dropDown"
          @checkName="checkName"
        />
        <div class="formTitle">
          <div></div>
          <div>一、企业基本信息</div>
        </div>
        <div class="content">
          <div class="label"><span>*</span> 企业名称全称</div>
          <van-field
            v-model="companyName"
            class="input"
            placeholder="请填写企业名称"
            @input="getCompanyList"
            :disabled="disabled"
          />
          <div class="label"><span>*</span> 企业成立日期</div>
          <van-field
            v-model="fromTime"
            class="input"
            placeholder="请填写企业成立日期"
            :readonly="isReadonly"
            @click="onClickDate"
            :disabled="disabled"
          />
          <van-popup v-model="datePick" round position="bottom">
            <van-datetime-picker
              v-model="currentDate"
              type="date"
              title="选择年月日"
              @cancel="datePick = false"
              @confirm="onDatePick"
            />
          </van-popup>
          <div class="label">
            <span>*</span> 主要产品(服务)所属国家高新技术领域
          </div>
          <van-field
            readonly
            clickable
            class="input"
            :value="field"
            placeholder="请选择"
            @click="showPickerOne = true"
          >
            <template #right-icon>
              <van-icon name="arrow-down" />
            </template>
          </van-field>
          <van-popup v-model="showPickerOne" round position="bottom">
            <van-picker
              show-toolbar
              :columns="columns"
              @cancel="showPickerOne = false"
              @change="onChange"
              @confirm="onConfirmField"
            />
          </van-popup>
        </div>
      </div>
      <div class="formItem">
        <div class="formTitle">
          <div></div>
          <div>二、科技成果转化</div>
        </div>
        <div class="content">
          <div class="label"><span>*</span> 近三年平均科技成果转化数</div>
          <div class="desc">
            (包括不限于：经登记技术交易合同、已验收科研类项目、经认定科技成果转化项目。分别针对不同产品)
          </div>
          <van-field
            readonly
            clickable
            class="input"
            :value="proportion"
            placeholder="请选择"
            @click="showPickerTwo = true"
          >
            <template #right-icon>
              <van-icon name="arrow-down" />
            </template>
          </van-field>
          <van-popup v-model="showPickerTwo" round position="bottom">
            <van-picker
              show-toolbar
              :columns="proportionColumns"
              @cancel="showPickerTwo = false"
              @confirm="onConfirmProportion"
            />
          </van-popup>
          <div class="label">
            <span>*</span> 上一年度高新技术产品(服务)占比情况
          </div>
          <radio-button v-model="valueOne" :flag="0" :options="optionOne" />
        </div>
      </div>
      <div class="formItem">
        <div class="formTitle">
          <div></div>
          <div>三、知识产权与参与标准制定</div>
        </div>
        <div class="content">
          <div class="label">1、I 类知识产权数量</div>
          <div class="desc">
            (包括：发明专利、植物新品种、国家级农作物品种、国家新药、国家一级中药保护品种、集成电路布图设计专有权。专利以获得授权证书为准)
          </div>
          <radio-button v-model="valueTwo" :flag="0" :options="optionTwo" />
          <div class="label">2、II 类知识产权数量</div>
          <div class="desc">
            (包括：实用新型专利、外观设计专利、软件著作权。专利以获得授权证书为准)
          </div>
          <radio-button v-model="valueThree" :flag="2" :options="optionThree" />
          <div class="label">3、知识产权获得方式</div>
          <radio-button v-model="valueFour" :flag="0" :options="optionFour" />
          <div class="label">
            4、企业参与编制国家标准、行业标准、检测方法、技术规范的情况
          </div>
          <radio-button v-model="valueFive" :flag="0" :options="optionFive" />
        </div>
      </div>
      <div class="preButton">
        <van-button class="next nextOne" type="info" @click="nextHandleOne"
          >下一步</van-button
        >
      </div>
    </div>
    <div class="partTwo" v-show="isShow.two">
      <div class="formItem">
        <div class="formTitle">
          <div></div>
          <div>四、研发团队及管理水平管理</div>
        </div>
        <div class="content">
          <div class="label">
            1、企业从事研发和相关技术创新活动的科技人员占企业当年职工总数的比例
          </div>
          <radio-button v-model="valueSix" :flag="0" :options="optionSix" />
          <div class="label">
            2、是否制定了企业研究开发的组织管理制度、建立了研发投入核算体系、编制了研发费用辅助账
          </div>
          <radio-button v-model="valueSeven" :flag="1" :options="optionSeven" />
          <div class="label">3、是否设立研发机构、是否开展产学研合作</div>
          <radio-button v-model="valueEight" :flag="3" :options="optionEight" />
          <div class="label">
            4、是否建立了科技成果转化的组织实施与激励奖励制度，建立开放式的创新创业平台
          </div>
          <radio-button
            v-model="valueNine"
            :flag="3"
            :options="optionNine"
            class="special"
          />
          <div class="label">
            5、是否建立了科技人员的培养进修、职工技能培训、优秀人才引进，以及人才绩效评价奖励制度
          </div>
          <radio-button v-model="valueTen" :flag="2" :options="optionTen" />
        </div>
      </div>
      <div class="preButton">
        <van-button class="before" plain type="info" @click="preHandleOne"
          >上一步</van-button
        >
        <van-button class="next" type="info" @click="nextHandleTwo"
          >下一步</van-button
        >
      </div>
    </div>
    <div class="partThree" v-show="isShow.three">
      <div class="formItem">
        <div class="formTitle">
          <div></div>
          <div>五、企业经营情况</div>
        </div>
        <div class="content">
          <div class="label">1、近三年净资产增长率（%）</div>
          <radio-button
            v-model="valueEleven"
            :flag="2"
            :options="optionEleven"
          />
          <div class="label">2、近三年销售收入增长率（%）</div>
          <radio-button
            v-model="valueTwelve"
            :flag="2"
            :options="optionTwelve"
          />
          <div class="label">
            3、企业近三个会计年度研发费用投入总额占同期销售收入总额的比例（%）
          </div>
          <radio-button
            v-model="valueThirteen"
            :flag="3"
            :options="optionThirteen"
            class="special"
          />
        </div>
      </div>
      <div class="note">
        <div>备注：</div>
        <div>
          （1）净资产增长率=1/2（第二年末净资产÷第一年末净资产+第三年末净资产÷第二年末净资产）-1
        </div>
        <div>
          （2）销售收入增长率=1/2（第二年销售收入÷第一年销售收入+第三年销售收入÷第二年销售收入）-1
        </div>
      </div>
      <div class="preButton">
        <van-button class="before" plain type="info" @click="preHandleTwo"
          >上一步</van-button
        >
        <van-button
          class="next"
          type="info"
          :loading="reportLoading"
          @click="highTechCompleteReport"
          >立即获取测评报告</van-button
        >
      </div>
    </div>
    <!-- 返回小程序 -->
    <div v-if="isWxEnv" class="back">
      <div class="back-wrap" @click="goback">
        <span>返回</span>
        <img src="@/assets/images/H5/back.png" alt="" srcset="" />
      </div>
    </div>
  </div>
</template>
<script>
import radioButton from "./components/radioButton";
import { highTechCompleteReportApi } from "@/api/enterpriseHighNewH5";
import {
  getCompanyInfo as getCompanyInfoApi,
  getCorpInfo as getCorpInfoApi,
} from "@/api/enterpriseHighNew";
import dropDown from "./components/dropDown.vue";
import moment from "moment";
import {setHeight} from "@/utils/zgzx";

const industry = {
  电子信息技术: [
    "软件",
    "微电子技术",
    "计算机产品及其网络应用技术",
    "通信技术",
    "广播影视技术",
    "新型电子元器件",
    "信息安全技术",
    "智能交通和轨道交通技术",
  ],
  生物与新医药技术: [
    "医药生物技术",
    "中药、天然药物",
    "化学药研究技术",
    "药物新剂型与制剂创制技术",
    "医疗仪器、设备与医学专业软件",
    "轻工和化工生物技术",
    "农业生物技术",
  ],
  航空航天技术: ["航空技术", "航天技术"],
  新材料技术: [
    "金属材料",
    "无机非金属材料",
    "高分子材料",
    "生物医用材料",
    "精细和专用化学品",
    "与文化艺术产业相关的新材料",
  ],
  高技术服务业: [
    "研发与设计服务",
    "检验检测认证与标准服务",
    "信息技术服务",
    "高技术专业化服务",
    "知识产权与成果转化服务",
    "电子商务与现代物流技术",
    "城市管理与社会服务",
    "文化创意产业支撑技术",
  ],
  新能源及节能技术: [
    "可再生清洁能源",
    "核能及氢能",
    "新型高效能量转换与储存技术",
    "高效节能技术",
  ],
  资源与环境技术: [
    "水污染控制与水资源利用技术",
    "大气污染控制技术",
    "固体废弃物处置与综合利用技术",
    "物理性污染防治技术",
    "环境监测及环境事故应急处理技术",
    "生态环境建设与保护技术",
    "清洁生产技术",
    "资源勘查、高效开采与综合利用技术",
  ],
  高新技术改造传统产业: [
    "工业生产过程控制系统",
    "安全生产技术",
    "高性能、智能化仪器仪表",
    "先进制造业工艺与装备",
    "新型机械",
    "电力系统与设备",
    "汽车及轨道车辆相关技术",
    "高技术船舶与海洋工程装备设计制造技术",
    "传统文化产业改造技术",
  ],
};
export default {
  name: "Evaluation",
  components: {
    radioButton,
    dropDown,
  },
  data() {
    return {
      form: [],
      companyName: "", //企业名称
      fromTime: "", //成立日期
      field: "", //所属高新技术领域
      proportion: "", //近三年平均技术成果转化数
      disabled: false,
      valueOne: "",
      valueTwo: "",
      valueThree: "",
      valueFour: "",
      valueFive: "",
      valueSix: "",
      valueSeven: "",
      valueEight: "",
      valueNine: "",
      valueTen: "",
      valueEleven: "",
      valueTwelve: "",
      valueThirteen: "",
      showPickerOne: false,
      showPickerTwo: false,
      columns: [
        { values: Object.keys(industry) },
        { values: industry["电子信息技术"] },
      ],
      proportionColumns: ["0项", "1项", "2项", "3项", "4项", "≥5项"],
      optionOne: ["≥60%", "<60%"],
      optionTwo: ["≥1项", "0项"],
      optionThree: ["≥5项", "4项", "3项", "2项", "1项", "0项"],
      optionFour: ["有自主研发", "仅有受让、受赠和并购等"],
      optionFive: ["有", "无"],
      optionSix: ["≥10%", "<10%"],
      optionSeven: ["满足1项", "满足2项", "满足3项", "都不满足"],
      optionEight: [
        "设立研发机构，并开展产学研合作",
        "设立研发机构，但没有开展产学研合作",
        "无研发机构，且没有开展产学研合作",
      ],
      optionNine: [
        "建立了科技成果转化的组织实施与激励奖励制度，并建立开放式的创新创业平台",
        "建立了科技成果转化的组织实施与激励奖励制度，但无建立开放式的创新创业平台",
        "无科技成果转化的组织实施与激励奖励制度，且无开放式的创新创业平台",
      ],
      optionTen: ["满足1项", "满足2项", "满足3项", "满足4项", "都不满足"],
      optionEleven: ["≥35%", "≥25%", "≥15%", "≥5%", ">0", "≤0"],
      optionTwelve: ["≥35%", "≥25%", "≥15%", "≥5%", ">0", "≤0"],
      optionThirteen: [
        "最近一年销售收入小于5000万元（含）的企业，比例≥5%",
        "最近一年销售收入在5000万元至2亿元（含）的企业，比例占比≥4%",
        "最近一年销售收入在2亿元以上的企业，比例占比≥3%",
        "以上情况都不达标",
      ],
      reportId: "",
      companyList: [], //公司列表
      visible: false,
      isReadonly: false,
      currentDate: new Date(),
      datePick: false,
      loading: true,
      reportLoading: false,
      isEmpty: false, //暂无数据
      isShow: {
        one: true,
        two: false,
        three: false,
      },
      isWxEnv: false, // 是否在微信小程序打开
    };
  },
  updated() {
    this.form = [
      {
        code: "1-1",
        content: this.companyName,
      },
      {
        code: "1-2",
        content: this.fromTime,
      },
      {
        code: "1-3",
        content: this.field,
      },
      {
        code: "2-1",
        content: this.proportion,
      },
      {
        code: "2-2",
        content: this.valueOne,
      },
      {
        code: "3-1",
        content: this.valueTwo,
      },
      {
        code: "3-2",
        content: this.valueThree,
      },
      {
        code: "3-3",
        content: this.valueFour,
      },
      {
        code: "3-4",
        content: this.valueFive,
      },
      {
        code: "4-1",
        content: this.valueSix,
      },
      {
        code: "4-2",
        content: this.valueSeven,
      },
      {
        code: "4-3",
        content: this.valueEight,
      },
      {
        code: "4-4",
        content: this.valueNine,
      },
      {
        code: "4-5",
        content: this.valueTen,
      },
      {
        code: "5-1",
        content: this.valueEleven,
      },
      {
        code: "5-2",
        content: this.valueTwelve,
      },
      {
        code: "5-3",
        content: this.valueThirteen,
      },
    ];
  },
  created() {
    //调用
    this.isWx().then((type) => {
      // this.$notify({
      //   type: "warning",
      //   message: type,
      // });
      this.isWxEnv = type == "mini-wx";
    });
    if (this.$route.query.userId) {
      let userInfo = {
        userId: this.$route.query.userId,
        username: this.$route.query.username,
        orgId: this.$route.query.orgId,
        orgName: this.$route.query.orgName,
        companyName: this.$route.query.companyName,
      };
      if (this.$route.query.applets) {
        userInfo.applets = this.$route.query.applets;
      }
      localStorage.setItem("userInfo", JSON.stringify(userInfo));
    }
  },
  mounted() {
    if (this.$route.params.companyName) {
      this.companyName = this.$route.params.companyName;
      this.disabled = true;
    }
    this.fromTime = this.$route.params.fromTime;
    this.getCorpInfo();
    const trigger = (el) => {
      if (this.visible) {
        if (
          this.$refs.dropDownRef.$el &&
          !this.$refs.dropDownRef.$el.contains(el.target)
        ) {
          this.visible = false;
          this.companyName = "";
        }
      }
    };
    document.addEventListener("click", trigger);
    setTimeout(() => {
      setHeight();
    }, 1000)
  },
  methods: {
    //函数
    isWx() {
      var ua = navigator.userAgent.toLowerCase();
      if (ua.match(/MicroMessenger/i) == "micromessenger") {
        return new Promise((resolve) => {
          this.$wx.miniProgram.getEnv(function (res) {
            if (res.miniprogram) {
              resolve("mini-wx");
            } else {
              resolve("wx");
            }
          });
        });
      } else {
        console.log("不在微信里");
        return new Promise((resolve) => {
          resolve("no-wx");
        });
      }
    },
    goback() {
      this.$wx.miniProgram.navigateTo({
        url: "/pages/index/index",
      });
    },
    nextHandleOne() {
      this.isShow.one = false;
      this.isShow.two = true;
      document.body.scrollIntoView();
    },
    nextHandleTwo() {
      this.isShow.two = false;
      this.isShow.three = true;
      document.body.scrollIntoView();
    },
    preHandleOne() {
      this.isShow.two = false;
      this.isShow.one = true;
      document.body.scrollIntoView();
    },
    preHandleTwo() {
      this.isShow.three = false;
      this.isShow.two = true;
      document.body.scrollIntoView();
    },
    onChange(picker, values) {
      picker.setColumnValues(1, industry[values[0]]);
    },
    onConfirmField(value) {
      this.field = value[0] + "/" + value[1];
      this.showPickerOne = false;
    },
    onConfirmProportion(value) {
      this.proportion = value;
      this.showPickerTwo = false;
    },
    checkName(item) {
      this.companyName = item;
      this.getCorpInfo();
    },
    //选择日期后确定
    onDatePick(value) {
      this.fromTime = moment(value).format("YYYY-MM-DD");
      this.datePick = false;
    },
    onClickDate() {
      if (!this.fromTime) {
        this.datePick = true;
      } else {
        this.datePick = false;
      }
    },
    // 高新企业测评报告-完整版
    async highTechCompleteReport() {
      this.reportLoading = true;
      const res = await highTechCompleteReportApi(this.form);
      if (res.code == 0) {
        this.reportLoading = false;
        document.body.scrollIntoView();
        let q = {
          reportId: res.data.reportId,
        }
        if (this.$route.query.sc) {
          q.sc = this.$route.query.sc;
        }
        this.$router.push({
          path: "/enterpriseHighNewH5/completeReport",
          query: q,
        });
      } else {
        this.reportLoading = false;
        // this.$notify('您有未填写的企业信息，请补全完成')
        this.$notify({
          type: "warning",
          message: "您有未填写的企业信息，请补全完成",
        });
      }
    },
    getCompanyList() {
      if (this.companyName.trim()) {
        this.visible = true;
        this.loading = true;
        clearTimeout(this.timer);
        this.timer = setTimeout(() => {
          this.getCompanyInfo();
        }, 800);
      } else {
        this.visible = false;
        this.isReadonly = false;
      }
    },
    // 获取公司列表
    async getCompanyInfo() {
      if (!this.companyName) {
        this.visible = false;
        return;
      }
      this.loading = true;
      const res = await getCompanyInfoApi({
        name: this.companyName,
      });
      if (res.code == 0) {
        this.companyList = res.data;
        this.loading = false;
        if (this.companyList.length > 0) {
          this.isEmpty = false;
        } else {
          this.isEmpty = true;
        }
      }
    },
    // 获取工商信息
    async getCorpInfo() {
      if (!this.companyName) return;
      const res = await getCorpInfoApi({
        companyName: this.companyName,
      });
      if (res.code == 0) {
        if (res.data.foundedTime) {
          this.fromTime = res.data.foundedTime;
          this.isReadonly = true;
        }
      }
    },
  },
};
</script>
<style lang="less" scoped>
.evaluation {
  .back {
    position: sticky;
    left: 1.93rem;
    bottom: 0.59rem;
    z-index: 999;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    .back-wrap {
      height: 100%;
      width: 3.6rem;
      height: 0.64rem;
      background: #edf1fd;
      box-shadow: 0px 0.02rem 0.06rem 0.04rem rgba(221, 230, 255, 1);
      border-radius: 0.38rem;
      border: 1px solid #385eef;
      font-size: 0.34rem;
      font-weight: 500;
      color: #5370ff;
      display: flex;
      align-items: center;
      justify-content: center;
      span {
        margin-right: 0.28rem;
      }
      img {
        width: 0.39rem;
        height: 0.38rem;
      }
    }
  }
  .preButton {
    height: 1.5rem;
    box-shadow: 0px 2px 15px 5px #eff5fa;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 0.2rem;
    .van-button {
      width: 3.3rem;
      height: 0.8rem;
    }
    .before {
      margin-right: 0.3rem;
      border-color: #0072f7;
    }
    .nextOne {
      width: 6.9rem;
    }
    .next {
      background-color: #0072f7;
      border: none;
    }
  }
  .pageTop {
    padding: 0 0.2rem;
    margin: 0 auto;
    .step {
      height: 0.88rem;
      display: grid;
      grid-template-columns: 1fr 1fr 1fr;
      .stepText {
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 0.24rem;
        .passed {
          color: #3371ff;
          margin-right: 0.1rem;
        }
        .arrowOne {
          margin-left: 0.5rem;
          color: #bfbfbf;
        }
        .arrowTwo {
          margin-left: 0.53rem;
          color: #bfbfbf;
        }
        .numOne {
          width: 0.24rem;
          height: 0.24rem;
          border-radius: 50%;
          background: #3371ff;
          color: white;
          text-align: center;
          line-height: 0.24rem;
          margin-right: 0.1rem;
          font-size: 0.14rem;
        }
        .write {
          font-weight: 500;
          color: rgba(0, 0, 0, 0.85);
        }
        .getReport {
          color: #aaaaaa;
        }
        .numTwo {
          width: 0.24rem;
          height: 0.24rem;
          border-radius: 50%;
          border: 1px solid rgba(0, 0, 0, 0.15);
          color: rgba(0, 0, 0, 0.25);
          text-align: center;
          line-height: 0.24rem;
          margin-right: 0.1rem;
          font-size: 0.14rem;
        }
      }
    }
  }
  .progress {
    width: 100%;
    height: 0.01rem;
    margin-bottom: 0.4rem;
    background: #e7e7e7;
    .proMiddle {
      width: 2.5rem;
      height: 0.02rem;
      background: #3371ff;
      margin-left: 2.2rem;
    }
  }
  .pageHead {
    margin-left: 0.2rem;
    .title {
      font-size: 0.28rem;
      font-weight: 500;
      margin: 0 0.16rem;
    }
    :last-child {
      font-size: 0.24rem;
      color: #999999;
    }
  }
  .formItem {
    width: 7.1rem;
    box-shadow: 0px 4px 14px 0px rgba(237, 243, 253, 0.47);
    border-radius: 4px;
    border: 1px solid rgba(0, 114, 247, 0.07);
    margin: 0.4rem auto 0 auto;
    position: relative;
    .dropDown {
      width: 6.5rem;
      height: 4rem;
      position: absolute;
      top: 2.61rem;
      left: 0.3rem;
      z-index: 999;
    }
    .formTitle {
      width: 7.1rem;
      height: 0.84rem;
      background: rgba(0, 114, 247, 0.07);
      border-radius: 7px 7px 0px 0px;
      display: flex;
      align-items: center;
      :first-child {
        width: 0.06rem;
        height: 0.32rem;
        background: #0072f7;
        border-radius: 0px 14px 14px 0px;
        margin-right: 0.24rem;
      }
      :last-child {
        font-size: 0.28rem;
        font-weight: 500;
      }
    }
    .content {
      padding: 0 0.3rem 0.4rem 0.3rem;
      .label {
        font-size: 0.26rem;
        font-weight: 500;
        margin-top: 0.5rem;
        span {
          color: #ff0000;
        }
      }
      .van-field--disabled {
        background: #fafafa;
      }
      .special {
        /deep/ .van-button {
          height: 1rem;
        }
        /deep/ .van-button__content {
          text-align: left;
        }
      }
      .desc {
        font-size: 0.24rem;
        color: #999999;
        margin-bottom: 0.2rem;
        margin-top: 0.1rem;
      }
    }
    .input {
      width: 6.5rem;
      //   height: 0.7rem;
      border-radius: 4px;
      border: 1px solid #d9d9d9;
      margin-top: 0.2rem;
    }
    /deep/ .van-cell {
      padding: 0.09rem 0.16rem;
    }
  }
  .note {
    width: 7.1rem;
    height: 2.64rem;
    background: #f9f9f9;
    border-radius: 4px;
    padding: 0.32rem;
    margin: 0.5rem auto;
    font-size: 0.22rem;
    color: #666666;
    div {
      line-height: 0.4rem;
    }
  }
}
</style>
